<ng-container *transloco="let t">
  @if (isLoading) {
    <div class="xi-loader-container__center">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
  @if (!isLoading) {
    <div side="left" class="user-list__list-wrapper">
      <div class="user-list__user-list-header">
        <h3 class="user-list__user-list-label">{{ t('user-list.users') }}</h3>
        @if (isAdmin && dataSource.data?.length) {
          <xi-fab
            icon="fab_plus"
            color="orca"
            buttonSize="normal"
            (onClick)="onCreateUser()"
            [disabled]="!canCreateUser()"
            [tooltip]="{ text: t('user-list.create-new-user'), direction: 12 }"
          ></xi-fab>
        }
      </div>
      <div class="user-list__searchbar">
        @if (searchInput.value) {
          <div class="user-list__searchbar_cancel_icons">
            <div class="user-list__searchbar-cancel-icon user-list__searchbar_cancel_icon--icon">
              <xi-icon icon="cancel_circle"></xi-icon>
            </div>
            <div class="user-list__searchbar-cancel-icon user-list__searchbar_cancel_icon--button">
              <xi-icon icon="cancel_circle_filled" (onClick)="onClearSearch(searchInput)"></xi-icon>
            </div>
          </div>
        }
        @if (!searchInput.value) {
          <div class="user-list__searchbar-search-icon">
            <xi-icon icon="search"></xi-icon>
          </div>
        }
        <input
          #searchInput
          [(ngModel)]="searchValue"
          placeholder="{{ t('user-list.search') }}"
          (input)="onSearchChanged($event.target.value)"
          class="user-list__input"
        />
      </div>
      @if (dataSource?.data?.length && !isLoading) {
        <cdk-virtual-scroll-viewport
          tvsItemSize
          class="virtual-viewport"
          [itemSize]="48"
          (scrolledIndexChange)="onScrollDown()"
        >
          <table
            mat-table
            [dataSource]="dataSource"
            matSort
            matSortDisableClear
            [matSortActive]="sort.active"
            [matSortDirection]="sort.direction"
            (matSortChange)="onSortChanged($event)"
            class="full-width user-list__user-list-table"
          >
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ t('user-list.email') }}</th>
              <td mat-cell *matCellDef="let element">
                <div
                  class="user-list__user-list-table-email"
                  matTooltipPosition="right"
                  [matTooltip]="element?.email.length > 26 ? element.email : null"
                >
                  {{ element.email | truncateEnd: 25 }}
                </div>
                <div
                  class="user-list__user-list-table-name"
                  matTooltipPosition="after"
                  [matTooltip]="
                    (element.first_name + ' ' + element.last_name).length > 26
                      ? element.first_name + ' ' + element.last_name
                      : null
                  "
                >
                  {{ element.first_name + ' ' + element.last_name | truncateEnd: 25 }}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="admin">
              <div class="checkbox-test">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="checkbox-test">
                  {{ t('user-list.admin') }}
                </th>
                <td mat-cell *matCellDef="let element" class="checkbox-test">
                  <mat-checkbox
                    [checked]="isAccountAdmin(element)"
                    [disabled]="!canChangeUserPermission(element)"
                    (change)="changeUserPermission($event, element)"
                    (click)="$event.stopImmediatePropagation()"
                  ></mat-checkbox>
                </td>
              </div>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              [class.user-list__user--selected]="row === this.selectedUser"
              class="user-list__user"
              (click)="!isSaving && onUserSelected(row)"
            ></tr>
            <tr class="user-list__no-table-data" *matNoDataRow>
              <td [attr.colspan]="displayedColumns.length">
                @if (users.length) {
                  <div class="user-list__no-results-content">
                    <p class="user-list__no-results-text">
                      {{ t('user-list.no-results-found') }}
                    </p>
                    <div class="user-list__no-results-button">
                      <xi-default-button
                        (onClick)="onClearSearch(searchInput)"
                        text="{{ t('user-list.clear-search-button') }}"
                      ></xi-default-button>
                    </div>
                  </div>
                }
              </td>
            </tr>
          </table>
        </cdk-virtual-scroll-viewport>
      }
      @if (showEmptySidePane) {
        <app-empty-side-panel
          emptyViewText="{{ t('user-list.empty-text') }}"
          emptyViewTitle="{{ t('user-list.empty-title') }}"
          ctaButtonText="{{ t('user-list.empty-cta-btn-text') }}"
          (ctaButtonClick)="onCreateUser()"
        ></app-empty-side-panel>
      }
    </div>
  }
</ng-container>
